import React from 'react'
import PropTypes from 'prop-types'

import Box from '../Box'
import Image from '../Image'

import Paragraph from './Paragraph'
import Title from './Title'

const DashboardGuideModule = (props) => {
  const { boxProps, children, gradientOverlay, imageProps, imageUrl } = props

  return (
    <Box
      border="1px solid"
      borderColor="lineColor"
      borderRadius={5}
      minHeight={220}
      position="relative"
      width="100%"
      {...boxProps}
    >
      <Image
        boxProps={{
          backgroundPosition: ['bottom left', 'center right'],
          borderRadius: 5,
          bottom: 0,
          left: 0,
          position: 'absolute',
          right: 0,
          top: 0,
          zIndex: 0,
          ...imageProps,
        }}
        url={imageUrl}
      />

      {gradientOverlay && (
        <Box
          background="linear-gradient(60deg, #FFFFFF 30%, rgba(255, 255, 255, 0) 70%)"
          borderRadius={5}
          bottom={0}
          left={0}
          position="absolute"
          right={0}
          top={0}
        />
      )}

      <Box flexDirection="row" marginTop="auto" maxWidth={['100%', '100%', '500px']} padding="large">
        <Box borderRadius={5} flexDirection="column" padding="medium" zIndex="1">
          {children}
        </Box>
      </Box>
    </Box>
  )
}

DashboardGuideModule.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
}

DashboardGuideModule.defaultProps = {
  gradientOverlay: true,
}

DashboardGuideModule.Paragraph = Paragraph
DashboardGuideModule.Title = Title

export default DashboardGuideModule
